const CommonToggle = ({ isActive, onChange, disabled }) => {
  return (
    <button disabled={disabled} className={`fa toggle-button ${isActive ? 'toggle-button_active' : ''}`} onClick={() => onChange()}>
      <span className='toggle-button__slider'/>
    </button>
  )
}

export default CommonToggle;